const New = () => import("../components/Views/AlteracaoMatricula/New.vue");
const List = () => import("../components/Views/AlteracaoMatricula/List.vue");
const View = () => import("../components/Views/AlteracaoMatricula/View.vue");
const Home = () => import("../components/Views/Home.vue");
const SelecaoDisciplinas = () =>
  import("../components/Views/AlteracaoMatricula/SelecaoDisciplinas.vue");

const breadcrumb = [
  { name: "IntegradON", link: process.env.INTERNO_URL },
  { name: "Alteração de Matrícula", link: "/alteracao-matricula" }
];

const alteracaoMatricula = [
  {
    path: "/alteracao-matricula",
    component: Home,
    children: [
      {
        path: "/alteracao-matricula",
        name: "Alteração de Matrícula",
        component: List,
        breadcrumb
      },
      {
        path: "/alteracao-matricula/new",
        name: "Nova Alteração de Matrícula",
        component: New,
        breadcrumb
      },
      {
        path: "/alteracao-matricula/view/:id",
        name: "Visualizar Alteração de Matrícula",
        component: View,
        breadcrumb
      },
      {
        path: "/alteracao-matricula/view/:id/:print",
        name: "Impressão de Alteração de Matrícula",
        component: View,
        breadcrumb
      },
      {
        path: "/alteracao-matricula/new/selecao-disciplinas",
        name: "Seleção de Disciplinas",
        component: SelecaoDisciplinas,
        breadcrumb
      }
    ]
  }
];

export default alteracaoMatricula;



// WEBPACK FOOTER //
// ./src/routes/alteracaoMatricula.js